import { apiClient } from '../../../../v4/core/apiClient';
import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myV1ActionEvent } from '../../../../v4/migration/actionAsEventMiddleware.connected';
import { createBookingService } from './BookingService.impl';
import { myBookingApi } from '../../../api/booking/booking.api.connected';
import { createBookingStatisticsApi } from '../../../api/booking-statistics/booking-statistics.api.http';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import AuthService from 'lib/auth/AuthService';

export const myBookingService = createBookingService({
  api: myBookingApi,
  statisticsApi: createBookingStatisticsApi(apiClient),
  queryClient,
  v1Event: myV1ActionEvent,
  services: {
    errorService: myErrorService,
    messageService: myMessageService
  },
  isAuthenticated: () => AuthService.isAuthenticated()
});
